<script setup>
import BaseModal from "../../global/modals/BaseModal.vue";
const emit = defineEmits(['close', 'error']);

const props = defineProps({
  token: {
    type: String,
    required: true,
  }
})

const handleCopy = () => {
  navigator.clipboard.writeText(props.token);
}
</script>

<template>
  <Teleport to="body">
    <BaseModal @close="emit('close')">
      <template #heading>
        API Key Generated
      </template>
      <div class="min-width">
        <p class="mt-4 help-text">
          Please make a note of your API Key, as this is the<br> only time it will be shown to you in full.
        </p>

        <div class="container mx-auto my-3">
          <span class="font-weight-bold key">
            {{ token }}
          </span>
          <span
            class="copy-btn"
            @click="handleCopy"
          >
            <svg-vue
              class="svg"
              icon="icons/copy-simple"
            />
          </span>
        </div>
      </div>
      <template #footer>
        <div class="w-100 d-flex justify-content-center">
          <button
            class="btn btn-info btn-lg button font-weight-bold mx-3 mb-0"
            @click="$emit('close')"
          >
            Confirm
          </button>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<style scoped>
.min-width {
  min-width: 675px;
}

.help-text {
  text-align: center;
  font-size: 18px;
  letter-spacing: -0.281px;
}

.container {
  display: flex;
  width: 453px;
  padding: 8px 0;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

.key {
  color: #616160;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  line-height: 29px;
  letter-spacing: 0.72px;
  background: #F8F7F5;
  padding: 10px 20px 11px;
  border-radius: 8px 0 0 8px;
}

.copy-btn {
  display: flex;
  width: 50px;
  height: 50px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 0 8px 8px 0;
  background: #DFDFDF;
  cursor: pointer;
}

.copy-btn:hover {
  background: #b5b4b4;
  transition: all 0.5s ease;
}

.svg {
  width: 24px;
}
</style>
